import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class ProfessionalAcademicCredentials extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_professional_academic_credentia');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'educational_qualifications')}><i class="fas fa-file-download"></i> Educational Qualifications</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'enrollment_number')}><i class="fas fa-file-download"></i> Enrollment Number</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'certificate_of_practice')}><i class="fas fa-file-download"></i> Certificate of Practice</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'part_time_employee_professional_academic_credentia';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
    }else{
      url = "/php/admin_part_time_employee_management_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#state_bar_council_name').val(data['state_bar_council_name']);
    $('#specialization_areas').val(data['specialization_areas']);
    $('#user_experience').val(data['user_experience']);

    $('#old_educational_qualifications').val(data['educational_qualifications_new_name']);
    $('#old_enrollment_number').val(data['enrollment_number_new_name']);
    $('#old_certificate_of_practice').val(data['certificate_of_practice_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['png','jpg','jpeg','JPEG','JPG','PNG','pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var state_bar_council_name    = window.isNullAndUndef($('#state_bar_council_name').val());
    var specialization_areas          = window.isNullAndUndef($('#specialization_areas').val());
    var user_experience           = window.isNullAndUndef($('#user_experience').val());

    var educational_qualifications_temp    = window.isNullAndUndef($('#educational_qualifications').val());
    var org_educational_qualifications     = $("#educational_qualifications").prop("files")[0];
    var educational_qualifications_name    = $('#educational_qualifications').val().split('\\').pop();

    var enrollment_number_temp        = window.isNullAndUndef($('#enrollment_number').val());
    var org_enrollment_number         = $("#enrollment_number").prop("files")[0];
    var enrollment_number_name        = $('#enrollment_number').val().split('\\').pop();

    var certificate_of_practice_temp        = window.isNullAndUndef($('#certificate_of_practice').val());
    var org_certificate_of_practice         = $("#certificate_of_practice").prop("files")[0];
    var certificate_of_practice_name        = $('#certificate_of_practice').val().split('\\').pop();


    var educational_qualifications_ext    = '';
    var enrollment_number_ext  = '';
    var certificate_of_practice_ext  = '';

    if(educational_qualifications_temp && enrollment_number_temp && certificate_of_practice_temp){
      educational_qualifications_ext       = educational_qualifications_temp.split('.').pop();
      enrollment_number_ext        = enrollment_number_temp.split('.').pop();
      certificate_of_practice_ext        = certificate_of_practice_temp.split('.').pop();
    }
    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(state_bar_council_name && specialization_areas && user_experience && file_main_ext.indexOf(educational_qualifications_ext) >= 0 && file_main_ext.indexOf(enrollment_number_ext) >= 0 && file_main_ext.indexOf(certificate_of_practice_ext) >= 0){
      var old_educational_qualifications                 = $('#old_educational_qualifications').val();
      var old_enrollment_number                  = $('#old_enrollment_number').val();
      var old_certificate_of_practice                  = $('#old_certificate_of_practice').val();
      var all_data                              = {};
      all_data['state_bar_council_name']        = window.return_false_null(state_bar_council_name);
      all_data['specialization_areas']              = window.return_false_null(specialization_areas);
      all_data['user_experience']               = window.return_false_null(user_experience);

      all_data['educational_qualifications']             = window.return_false_null(educational_qualifications_name);
      all_data['enrollment_number']                 = window.return_false_null(enrollment_number_name);
      all_data['certificate_of_practice']                 = window.return_false_null(certificate_of_practice_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('educational_qualifications',org_educational_qualifications);
      body.append('old_educational_qualifications',old_educational_qualifications);
      body.append('enrollment_number',org_enrollment_number);
      body.append('old_enrollment_number',old_enrollment_number);
      body.append('certificate_of_practice',org_certificate_of_practice);
      body.append('old_certificate_of_practice',old_certificate_of_practice);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_professional_academic_credentia');
      body.append('function','add_part_time_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('state_bar_council_name','specialization_areas','user_experience','educational_qualifications','enrollment_number','certificate_of_practice');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }

  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_educational_qualifications" placeholder=""/>
                                        <input type="file" className="form-control" id="educational_qualifications" placeholder="Educational Qualifications"/>
                                        <label for="name">Educational Qualifications</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                  <label for="name">Bar Council Enrollment Details</label>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_enrollment_number" placeholder=""/>
                                        <input type="file" className="form-control" id="enrollment_number" placeholder="Enrollment Number"/>
                                        <label for="name">Enrollment Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="state_bar_council_name" placeholder="State Bar Council Name"/>
                                        <label for="name">State Bar Council Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_certificate_of_practice" placeholder=""/>
                                        <input type="file" className="form-control" id="certificate_of_practice" placeholder="Certificate of Practice"/>
                                        <label for="name">Certificate of Practice</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="specialization_areas" placeholder="Specialization Areas"/>
                                        <label for="name">Specialization Areas</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="user_experience" placeholder="Years of Legal Experience"/>
                                        <label for="name">Years of Legal Experience</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF, JPEG, JPG & PNG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default ProfessionalAcademicCredentials;
